import { Heading } from '@lmc/ui-kit'
import { FC } from 'react'
import styled from 'styled-components'

type Props = { title: string; onClick?: () => void }

export const CardTitle: FC<Props> = ({ title, onClick }) => (
  <div onClick={onClick}>
    <StyledHeading level={4}>{title}</StyledHeading>
  </div>
)

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  margin-bottom: 5px;
  font-weight: 700;
`
